import React from 'react';
import { Status } from 'Common/parameterEnums';
import CreateVelocityForm from 'Components/CreateVelocityForm';
import Layout from 'Components/Layout';
import RouteLoading from 'Components/RouteLoading';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import useGetVelocityConfigByRuleSetId from 'Hooks/query-hooks/parameters/useGetVelocityConfigByRuleSetId';
import errorController from 'Components/ErrorScreens';

const CreateVelocity: React.FC<{}> = () => {
    const ruleSetId = sessionStorage.getItem('ruleSetId') || '';
    const velocityConfigAPI = useGetVelocityConfigByRuleSetId(ruleSetId);
    const parametersAPI = useGetParameters({
        queryParams: {
            status: JSON.stringify(['active']),
            source: JSON.stringify(['system'])
        }
    });

    if (velocityConfigAPI.isLoading || velocityConfigAPI.isFetching || parametersAPI.isLoading) {
        return <RouteLoading />;
    }

    if (velocityConfigAPI.isError || parametersAPI.isError) {
        const { errorCmp } = errorController([velocityConfigAPI.error, parametersAPI.error]);
        return errorCmp;
    }

    const initialValues: ParameterVelocityFormSchema = {
        fieldName: '',
        displayName: '',
        description: '',
        type: '',
        status: Status.DRAFT,
        includeCurrentEvent: false,
        velocityType: '',
        aggregationField: [],
        timeField: velocityConfigAPI.data.timeField,
        // statically defined default values in FE
        timePeriod: {
            type: 'value',
            duration: 1,
            unit: []
        },
        indexes: [],
        filters: []
    };
    return (
        <Layout>
            <CreateVelocityForm
                initialValues={initialValues}
                disableInputField={false}
                parameterData={parametersAPI.data}
                velocityConfigData={velocityConfigAPI.data}
            />
        </Layout>
    );
};

export default CreateVelocity;
